// Shared custom-domain record statuses, mirrored from the backend's DMN_* constants
// (app/api-v3/constants.js). Kept in one place so CustomDomainTable and the
// "add domain" modal route each status to the same actions.
export const STATUS_CONNECTED = 'CONNECTED'
export const STATUS_INIT = 'INITIATED'
export const STATUS_FAILED = 'FAILED'
export const STATUS_DISABLED = 'DISABLED'
export const STATUS_INCOMPLETE = 'INCOMPLETE'

export const getStatusLabel = (status = '') => {
  if (status.toUpperCase() === STATUS_CONNECTED) {
    return 'VALIDATED'
  } else {
    return status.toUpperCase()
  }
}
